import React from 'react';
import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../../lib/theme-context.js';
import { Button } from '../ui/button';

export const ControlBridgeThemeToggle: React.FC = () => {
  const { theme, setTheme } = useTheme();

  const toggleTheme = () => {
    setTheme(theme === 'light' ? 'classic' : 'light');
  };

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={toggleTheme}
      className={theme === 'light' 
        ? "text-slate-400 hover:text-white flex items-center gap-2" 
        : "text-slate-400 hover:text-white flex items-center gap-2"
      }
    >
      {theme === 'light' ? (
        <Moon className="w-4 h-4" />
      ) : (
        <Sun className="w-4 h-4" />
      )}
      <span className="text-xs">{theme === 'light' ? 'Dark' : 'Light'}</span>
    </Button>
  );
};
